module.exports = __webpack_public_path__ + "static/img/regardWePic1.ed83353.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/regardWePic1.jpg
// module id = jzHE
// module chunks = 0